import DialogTitle from "@mui/material/DialogTitle";
import { Box, Dialog, DialogContent, FormControl, FormLabel, IconButton, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import React, { useState } from "react";
import { OpeningHoursForDay2 } from "./OpeningHoursSettings.tsx";
import TranslationWrapper from "../../old/beheer/components/TranslationWrapper/TranslationWrapper.tsx";
import { DatePicker } from "@mui/x-date-pickers";
import { addDays, addYears, format, parse } from "date-fns";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";

type CopyExceptionDialogProps<T> = {
  date: string;
  timeRanges: OpeningHoursForDay2<T>[];
  open: boolean;
  onSave: (selectedDates: string[], timeRanges: OpeningHoursForDay2<T>[]) => void;
  onClose: () => void;
};

export const CopyExceptionDialog = <T,>({ date, timeRanges, open, onSave, onClose }: CopyExceptionDialogProps<T>) => {
  const [selectedDates, setSelectedDates] = useState<Date[]>([addDays(parse(date, "yyyy-MM-dd", new Date()), 1)]);

  return (
    <Dialog open={open}>
      <DialogTitle sx={{ m: 0, p: 2 }} id={"customized-dialog-title"}>
        <Typography>
          Select the dates to apply
          {timeRanges.map((value, index) => {
            if (timeRanges.length - 1 === index) {
              return ` ${value.hours} `;
            }

            return ` ${value.hours} and `;
          })}
          to.
        </Typography>
      </DialogTitle>
      <IconButton
        aria-label={"close"}
        onClick={onClose}
        sx={(theme) => ({
          position: "absolute",
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>
        <Box sx={{ padding: 3 }}>
          <FormControl component={"fieldset"}>
            <FormLabel component={"legend"}>
              <TranslationWrapper tKey={"AddExceptionDialog.Select Dates"} tDefault={"Select Dates"} />
            </FormLabel>
            {selectedDates.map((selectedDate) => {
              return (
                <DatePicker
                  key={selectedDate.toDateString()}
                  openTo={"day"}
                  minDate={new Date()}
                  maxDate={addYears(new Date(), 5)}
                  value={selectedDate}
                  onChange={(value) => {
                    if (value !== null) {
                      setSelectedDates([value]);
                    }
                  }}
                  sx={{ mb: 1 }}
                />
              );
            })}
          </FormControl>
          <Box>
            <IconButton
              onClick={() => {
                setSelectedDates((prevState) => {
                  return [...prevState, addDays(prevState[prevState.length - 1], 1)];
                });
              }}
            >
              <AddIcon />
            </IconButton>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          type={"submit"}
          autoFocus
          onClick={() => {
            const dates = selectedDates.map((selectedDate) => {
              return format(selectedDate, "yyyy-MM-dd");
            });

            onSave(dates, timeRanges);
          }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};
